module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/TIIM-small-d97b5b7e4dfcb9b6832879921855f64b.png";